/**
 * Logo component.
 * @module components/theme/Logo/Logo
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import { Image } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';

import LogoImage from '@plone/volto/components/theme/Logo/Logo.svg';
import Logo70years from 'volto-fzj-internet/icons/logo-fzj-70.svg'

const messages = defineMessages({
  site: {
    id: 'Back-to-Home-page',
    defaultMessage: 'Back to Home page',
  },
  plonesite: {
    id: 'logo-fzj',
    defaultMessage: 'Logo of the Forschungszentrum Jülich',
  },
});
/**
 * Logo component class.
 * @function Logo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const Logo = () => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);
  const fzjsettings = useSelector((state) => state.fzjsettings.settings);
  const intl = useIntl();

  const logosrc = fzjsettings?.logo?.filename
    ? `${settings.apiPath}/@@project-logo/${fzjsettings.logo.filename}`
    : LogoImage;

  return (
    <Link
      to={settings.isMultilingual ? `/${lang}` : '/'}
      title={intl.formatMessage(messages.site)}
    >
      <Image
        src={logosrc}
        alt={intl.formatMessage(messages.plonesite)}
        title={intl.formatMessage(messages.site)}
      />
    </Link>
  );
};

export default Logo;
